(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mod-collection"]) return;
  try {
    
  /* Result count and empty state follow the filter module in
     pultec-modern.js, which toggles [hidden] on each cell on click. */
  document.querySelectorAll('[data-filterbar]').forEach(function (bar) {
    var grid = document.querySelector(bar.getAttribute('data-filterbar'));
    var out = document.querySelector('[data-filter-count]');
    var empty = document.querySelector('[data-filter-empty]');
    if (!grid || !out) return;
    bar.addEventListener('click', function () {
      setTimeout(function () {
        var n = grid.querySelectorAll('.mod-cell:not([hidden])').length;
        out.textContent = n + (n === 1 ? ' unit' : ' units');
        if (empty) empty.hidden = n !== 0;
      }, 0);
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mod-product"]) return;
  try {
    
  /* Gallery: thumbnails swap the stage. Markup is complete without this. */
  document.querySelectorAll('[data-gallery]').forEach(function (root) {
    var main = root.querySelector('[data-gallery-main]');
    var cap = root.querySelector('[data-gallery-cap]');
    var count = root.querySelector('[data-gallery-count]');
    var thumbs = root.querySelectorAll('[data-gallery-thumb]');
    if (!main || thumbs.length < 2) return;
    thumbs.forEach(function (t, i) {
      t.addEventListener('click', function () {
        main.src = t.getAttribute('data-src');
        main.srcset = t.getAttribute('data-srcset') || '';
        main.alt = t.getAttribute('data-alt') || '';
        if (cap) cap.textContent = t.getAttribute('data-cap') || '';
        if (count) count.textContent = (i + 1) + ' / ' + thumbs.length;
        thumbs.forEach(function (x) { x.setAttribute('aria-selected', x === t ? 'true' : 'false'); });
      });
    });
    root.addEventListener('keydown', function (e) {
      if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') return;
      var cur = Array.prototype.findIndex.call(thumbs, function (x) { return x.getAttribute('aria-selected') === 'true'; });
      var next = (cur + (e.key === 'ArrowRight' ? 1 : -1) + thumbs.length) % thumbs.length;
      thumbs[next].click(); thumbs[next].focus(); e.preventDefault();
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mod-register"] && !Shopify.designMode) return;
  try {
    
  /* Conditional fields on the built-in registration form. Does nothing once
     an app block has taken over, because none of these hooks are present. */
  document.querySelectorAll('[data-reg-form]').forEach(function (form) {
    var triggers = form.querySelectorAll('[data-reveals]');
    var boxes = form.querySelectorAll('[data-reveal]');
    if (!triggers.length || !boxes.length) return;

    function refresh() {
      var on = {};
      triggers.forEach(function (t) {
        var key = t.getAttribute('data-reveals');
        on[key] = on[key] || t.checked;
      });
      boxes.forEach(function (box) {
        var show = !!on[box.getAttribute('data-reveal')];
        box.hidden = !show;
        box.querySelectorAll('input, select, textarea').forEach(function (f) {
          if (f.getAttribute('data-required-when-shown') === 'true') f.required = show;
          if (!show) f.value = '';
        });
      });
    }

    form.addEventListener('change', refresh);
    refresh();
  });

  } catch(e) { console.error(e); }
})();
})();
